var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4994 24.2423L26.6723 12.9531C25.7932 10.8865 24.4823 9.71444 22.9863 9.63732C21.5058 9.56021 20.0715 10.5935 18.9765 12.5676L16.0463 17.8266C15.4294 18.937 14.5504 19.6002 13.5942 19.6773C12.6225 19.7698 11.6509 19.2609 10.8644 18.2584L10.5251 17.8266C9.43011 16.454 8.07295 15.7909 6.68495 15.9297C5.29694 16.0685 4.10943 17.0246 3.32289 18.5823L0.654839 23.903C-0.301341 25.8308 -0.208808 28.067 0.917018 29.8868C2.04284 31.7066 4.00147 32.8016 6.14517 32.8016H25.824C27.8906 32.8016 29.8184 31.7683 30.9596 30.041C32.1317 28.3137 32.3168 26.1392 31.4994 24.2423Z",
    fill: "#8E9BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29036 11.2272C11.1693 11.2272 13.503 8.89341 13.503 6.01449C13.503 3.13558 11.1693 0.801758 8.29036 0.801758C5.41146 0.801758 3.07764 3.13558 3.07764 6.01449C3.07764 8.89341 5.41146 11.2272 8.29036 11.2272Z",
    fill: "#8E9BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-Image.1d3a5867e19ec1e7633c7c03f5195e5c.svg";
export { ForwardRef as ReactComponent };